export default "__VITE_ASSET__2P5i5k4h__"